import React from "react";
import "../css/Contact.css";

function Contact() {
  return (
    <div className="Contact-root-container">
      <h4> Contact </h4>
    </div>
  );
}

export default Contact;
